<template>
  <div class="">
    <top-header :type="6" placeholder="查看资料" fontSize="0.32rem" />
    <div class="form_con">
      <div class="inner_con">
        <h5>实名认证</h5>
        <!-- 卖方 -->
        <div v-if="type == 0 && obj">
          <div>
            <div class="row m_flex_box flex_vc">
              <div class="inner flex-1">
                类别：<span class="text">出卖方</span>
              </div>
              <div class="inner flex-1">
                姓名：<span class="text">{{obj.bargainor}}</span>
              </div>
            </div>
            <div class="row m_flex_box flex_vc flex_jz">
              <div class="inner flex-1">
                身份证号：<span class="text">{{obj.barPassNo}}</span>
              </div>
            </div>
          </div>
          <div v-if="obj.contractApprovalCertificationRecordBLG">
            <div class="row m_flex_box flex_vc">
              <div class="inner flex-1">
                类别：<span class="text">法人监护人</span>
              </div>
              <div class="inner flex-1">
                姓名：<span class="text">{{obj.bLGName}}</span>
              </div>
            </div>
            <div class="row m_flex_box flex_vc flex_jz">
              <div class="inner flex-1">
                身份证号：<span class="text">{{obj.bLGPassNo}}</span>
              </div>
            </div>
          </div>
          <div v-if="obj.contractApprovalCertificationRecordBD">
            <div class="row m_flex_box flex_vc">
              <div class="inner flex-1">
                类别：<span class="text">代理人</span>
              </div>
              <div class="inner flex-1">
                姓名：<span class="text">{{obj.barDeputy}}</span>
              </div>
            </div>
            <div class="row m_flex_box flex_vc flex_jz">
              <div class="inner flex-1">
                身份证号：<span class="text">{{obj.bDPassNo}}</span>
              </div>
            </div>
          </div>
          <div v-if="contractTraders && contractTraders.length > 0">
            <div v-for="(item, index) in contractTraders" :key="index">
              <div class="row m_flex_box flex_vc">
                <div class="inner flex-1">
                  类别：<span class="text">出卖方共有人</span>
                </div>
                <div class="inner flex-1">
                  姓名：<span class="text">{{item.traderName}}</span>
                </div>
              </div>
              <div class="row m_flex_box flex_vc flex_jz">
                <div class="inner flex-1">
                  身份证号：<span class="text">{{item.idNumber}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 买方 -->
        <div v-if="type == 1  && obj">
          <div>
            <div class="row m_flex_box flex_vc">
              <div class="inner flex-1">
                类别：<span class="text">买受方</span>
              </div>
              <div class="inner flex-1">
                姓名：<span class="text">{{obj.purchaser}}</span>
              </div>
            </div>
            <div class="row m_flex_box flex_vc flex_jz">
              <div class="inner flex-1">
                身份证号：<span class="text">{{obj.purPassNo}}</span>
              </div>
            </div>
          </div>
          <div v-if="obj.contractApprovalCertificationRecordPLG">
            <div class="row m_flex_box flex_vc">
              <div class="inner flex-1">
                类别：<span class="text">法人监护人</span>
              </div>
              <div class="inner flex-1">
                姓名：<span class="text">{{obj.pLGName}}</span>
              </div>
            </div>
            <div class="row m_flex_box flex_vc flex_jz">
              <div class="inner flex-1">
                身份证号：<span class="text">{{obj.pLGPassNo}}</span>
              </div>
            </div>
          </div>
          <div v-if="obj.contractApprovalCertificationRecordPD">
            <div class="row m_flex_box flex_vc">
              <div class="inner flex-1">
                类别：<span class="text">代理人</span>
              </div>
              <div class="inner flex-1">
                姓名：<span class="text">{{obj.purDeputy}}</span>
              </div>
            </div>
            <div class="row m_flex_box flex_vc flex_jz">
              <div class="inner flex-1">
                身份证号：<span class="text">{{obj.pDPassNo}}</span>
              </div>
            </div>
          </div>
          <div v-if="contractTraders && contractTraders.length > 0">
            <div v-for="(item, index) in contractTraders" :key="index">
              <div class="row m_flex_box flex_vc">
                <div class="inner flex-1">
                  类别：<span class="text">买受方共有人</span>
                </div>
                <div class="inner flex-1">
                  姓名：<span class="text">{{item.traderName}}</span>
                </div>
              </div>
              <div class="row m_flex_box flex_vc flex_jz">
                <div class="inner flex-1">
                  身份证号：<span class="text">{{item.idNumber}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inner_con" v-for="(item, index) in sysDictionaryCodeList" :key="index">
        <h5>{{item.dictKey}}</h5>
        <div class="pic_con" v-for="(inner, ind) in (type == 0 ? item.contractApprovalFileTypeBList : item.contractApprovalFileTypePList)" :key="ind">
          <div>
            <p>{{inner.fileName}}<span>{{inner.required == 1 ? '（必填项）' : '（选填项）'}}</span></p>
            <div class="pic_inner">
              <van-uploader v-model="inner.contractApprovalFileList" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="to_home" @click="$router.replace('/mine')" src="@/assets/img/index/99.png" alt="">
  </div>
</template>

<script>
import topHeader from '@/components/header'
import qs from 'qs'
export default {
  data() {
    return {
      type: '',
      id: '',
      fileList: [],
      imgCon: [],
      sysDictionaryCodeList: [],
      contractTraders: [],
      obj: null
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.type = this.$route.query.type;
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    toTest(state, id) {
      if(state == 3) {
        return;
      }
      this.$router.push({
        path: '/testIdCard',
        query: {
          id
        }
      })
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 6000 * 1024) {
        this.$toast('文件大小不得超过6M');
        return false;
      }
      return true;
    },
    afterRead(index, ind, id) {
      return (file, obj) => {
        console.log(id)
        const formData = new FormData();
        formData.append('contractApprovalId', this.$route.query.id);
        formData.append('contractApprovalFileTypeId', id);
        formData.append('file', file.file);
        this.$http({
        url: 'cms/contractApprovalFile/reg/upImgFile.do',
        method: 'POST',
          headers: { //添加请求头
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        }).then(res => {
          this.$set(this.sysDictionaryCodeList[index][this.type == 0 ? 'contractApprovalFileTypeBList' : 'contractApprovalFileTypePList'][ind]['contractApprovalFileList'], obj.index, (Object.assign({}, this.sysDictionaryCodeList[index][this.type == 0 ? 'contractApprovalFileTypeBList' : 'contractApprovalFileTypePList'][ind]['contractApprovalFileList'][obj.index], res.obj)));
        })
      }
    },
    deletePic(index, ind) {
      return (file, obj) => {
        console.log(file)
        this.$http.post('cms/contractApprovalFile/reg/delImg.do', qs.stringify({
          contractApprovalFileId: file.id,
          fileId: file.sysFile.id,
          area: file.area
        })).then(res => {
          if(res.success) {
            this.sysDictionaryCodeList[index][this.type == 0 ? 'contractApprovalFileTypeBList' : 'contractApprovalFileTypePList'][ind]['contractApprovalFileList'].splice(obj.index, 1);
            this.$toast('删除成功');
          }
        })
      }
    },
    getDetail() {
      let url = '';
      if (this.type == 0) {
        //出售、卖方
        url = "cms/contractApprovalFile/reg/getListByTByB.do";
      } else if (this.type == 1) {
        //购买、买方
        url = "cms/contractApprovalFile/reg/getListByTByP.do";
      }
      this.$http.post(url, qs.stringify({
        id: this.id
      })).then(res => {
        if(res.success) {
          this.obj = res.obj.contractData;
          this.contractTraders = res.obj.contractData.contractTraders;
          let sysDictionaryCodeList = [];
          if (this.type == 0) {
            //出售、卖方
            sysDictionaryCodeList = JSON.parse(JSON.stringify(res.obj.sysDictionaryCodeB))
          } else if (this.type == 1) {
            //购买、买方
            sysDictionaryCodeList = JSON.parse(JSON.stringify(res.obj.sysDictionaryCodeP))
          }
          const codeArr = [];
          for (var i in sysDictionaryCodeList) {
            i = parseInt(i);
            const dictValue = sysDictionaryCodeList[i].dictValue;
            if (dictValue == 2 || dictValue == 3) {
              //法人、监护人
              if (this.type == 0) {
                //出卖方
                if (this.obj.barLegalOrGuar == 0) {
                 codeArr.push(dictValue)
                }
              } else {
                //买受方
                if (this.obj.purLegalOrGuar == 0) {
                  codeArr.push(dictValue)
                }
              }
            }if (dictValue == 4) {
              //代理人
              if (this.type == 0) {
                //出卖方
                if (!this.obj.barDeputy) {
                  codeArr.push(dictValue);
                }
              } else {
                //买受方
                if (!this.obj.purDeputy) {
                  codeArr.push(dictValue);
                }
              }
            }
            if (dictValue == 5) {
              //共有人
              if (!this.contractTraders || this.contractTraders.length == 0) {
                codeArr.push(dictValue);
              }
            }
          }
          sysDictionaryCodeList = sysDictionaryCodeList.filter(item => {
            return !codeArr.includes(item.dictValue)
          });
          sysDictionaryCodeList.forEach(item => {
            item[this.type == 0 ? 'contractApprovalFileTypeBList' : 'contractApprovalFileTypePList'].forEach(inner => {
              inner.contractApprovalFileList.forEach(list => {
                list.content = 'data:image/jpeg;base64,' + list.sysFile.base64
              })
            })
          })
          this.sysDictionaryCodeList = sysDictionaryCodeList;
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
  .tips{
    font-size: 0.22rem;
    color: #F50707;
    background-color: #f5f5f5;
    padding: 0.12rem 0.26rem;
    line-height: 0.4rem;
  }
  .form_con{
    padding: 0.26rem;
    .inner_con{
      margin-bottom: 0.5rem;
      h5{
        font-size: 0.36rem;
        font-weight: 800;
      }
      .row{
        border-bottom: 1px solid #f5f5f5;
        padding: 0.4rem 0;
        font-size: 0.3rem;
        .icon{
          padding: 0.04rem 0.08rem;
          border-radius: 0.04rem;
          font-size: 0.22rem;
          background-color: #2F72F5;
          color: #fff;
          &.disabled{
            color: #666666;
            background-color: #F3F3F3;
          }
        }
      }
    }
    .pic_con{
      padding: 0.4rem 0 0;
      p{
        font-size: 0.3rem;
        margin-bottom: 0.45rem;
      }
      .pic_inner{
        /deep/
        .van-uploader__wrapper{
          margin-right: -8px;
        }
      }
    }
    /deep/
    .van-uploader__preview-delete{
      display: none;
    }
    /deep/
    .van-uploader__upload{
      display: none;
    }
  }
</style>